"use client";

import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import useIsomorphicLayoutEffect from "../animations/useIsomorphicLayoutEffect";
export type HamburgerButtonProps = {
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
};
export const HamburgerButton: React.FC<HamburgerButtonProps> = ({
  onClick,
}) => {
  const el = useRef(null);
  const tl = useRef<gsap.core.Timeline | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    tl.current?.reversed() ? tl.current?.restart() : tl.current?.reverse();
    onClick(event);
  };

  useIsomorphicLayoutEffect(() => {
    //console.log(duration, x, y, delay, ease);
    const ctx = gsap.context(() => {
      tl.current = gsap
        .timeline({ paused: true, reversed: true })
        //.set("", { className: "-=closemenu" })
        //.set("", { className: "+=openmenu" })
        .to(
          " .top",
          { y: "-9px", transformOrigin: "50% 50%", duration: 0.2 },
          "burg"
        )
        .to(
          " .bot",
          { y: "9px", transformOrigin: "50% 50%", duration: 0.2 },
          "burg"
        )
        .to(
          " .mid",
          { scale: 0.1, transformOrigin: "50% 50%", duration: 0.2 },
          "burg"
        )
        .add("rotate")
        .to(" .top", { y: "5", duration: 0.2 }, "rotate")
        .to(" .bot", { y: "-5", duration: 0.2 }, "rotate")
        .to(
          " .top",

          { rotationZ: 45, transformOrigin: "50% 50%", duration: 0.2 },
          "rotate"
        )
        .to(
          " .bot",

          { rotationZ: -45, transformOrigin: "50% 50%", duration: 0.2 },
          "rotate"
        );
    }, el);

    return () => ctx.revert(); // cleanup
  }, []);

  return (
    <button ref={el} onClick={handleClick} className="fill" title="Menu" aria-label="Menu">
      <svg
        /// <reference path="=" />

        id="burger"
        width="30"
        className="openmenu fill-white"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path className="top fill-white" d="M0 9h30v2H0z" />
        <line
          className="mid fill-white"
          x1="0"
          y1="15"
          x2="30"
          y2="15"
          stroke="white"
          strokeWidth="2"
          vectorEffect="non-scaling-stroke"
        />
        <path className="bot" d="M0 19h30v2H0z" />
      </svg>
    </button>
  );
};

export default HamburgerButton;
